// Rolls item offerings for Item Nodes.

import { ITEMS, type ItemId } from "../../data/items";
import type { RNG } from "../../game/RNG";

const ALL_ITEMS: ItemId[] = Object.keys(ITEMS) as ItemId[];

export function randomItemReward(rng: RNG, count = 3): ItemId[] {
  const pool = [...ALL_ITEMS];
  rng.shuffle(pool);
  return pool.slice(0, Math.min(count, pool.length));
}

export function itemDisplayName(id: ItemId): string {
  return ITEMS[id]?.name ?? id;
}
